module.exports = __webpack_public_path__ + "img/cooperate_34.b7495cf6.png";